import { Typography } from "@mui/material";
import React from "react";

export default function SectionTitle({ title, bold, centered }) {
  return (
    <Typography
      variant="h2"
      sx={{
        fontSize: { xs: "25px", lg: "32.5px" },
        fontWeight: bold ? 700 : 500,
        margin: 0,
        mt: 1,
        opacity: 0.9,
        textAlign: { xs: "center", md: centered ? "center" : "left" },
      }}
    >
      {title.toUpperCase()}
    </Typography>
  );
}
